import React, { Component, ErrorInfo } from "react";
import posthog from "posthog-js";
import ErrorPage from "./ErrorPage";

interface Props {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({ hasError: true });

        posthog.capture("Error", {
            error: error.toString(),
        });

        console.error("ErrorBoundary", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? <ErrorPage />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
